import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Seo from "../components/Seo";
import LEGAL from "../data/legal";

export default function LegalPage({ docKey }) {
  const doc = LEGAL[docKey];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [docKey]);

  if (!doc) return null;

  return (
    <div className="pt-32 pb-24 relative z-10 min-h-screen">
      <Seo title={doc.title} description={`${doc.title} — M + J s.r.o., alukola-bazar.cz`} />

      <div className="max-w-[900px] mx-auto px-5 md:px-10">
        <Link
          to="/"
          data-testid="legal-back"
          className="inline-flex items-center gap-2 font-head uppercase tracking-wider text-sm text-white/60 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft size={16} /> Zpět na úvod
        </Link>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="font-head uppercase tracking-[0.3em] text-xs text-[#ff3b30] mb-4">Právní dokument</div>
          <h1 data-testid="legal-title" className="font-display text-4xl md:text-6xl leading-[0.9] mb-3">
            {doc.title}
          </h1>
          {doc.updated && (
            <p className="text-white/40 text-sm mb-12">Poslední aktualizace: {doc.updated}</p>
          )}
        </motion.div>

        <div className="space-y-10">
          {doc.sections.map((sec, i) => (
            <section key={i} className="border-t border-white/10 pt-8">
              <h2 className="font-head text-lg md:text-xl font-semibold mb-4">{sec.h}</h2>
              {sec.p &&
                sec.p.map((para, j) => (
                  <p key={j} className="text-white/65 leading-relaxed mb-3">
                    {para}
                  </p>
                ))}
              {sec.li && (
                <ul className="list-disc pl-5 space-y-2 text-white/65 leading-relaxed mt-2">
                  {sec.li.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
